/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/kakao" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsKakao } from "./constants";
import type { AppsAppGroupIdChartsKakaoResult } from "./types";
import { isAppsAppGroupIdChartsKakaoResult } from "./validators";

export const getAppsAppGroupIdChartsKakao = reactQueryFetcherAdapter(
  appsAppGroupIdChartsKakao,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsKakaoResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/kakao`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAppsAppGroupIdChartsKakaoResult
);
